import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownContent, DropdownItem, IconButton, Scrollbar, TimePicker } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { uiStore } from 'shared/store/uiStore'
import { IS_APP_LIGHT } from 'shared/config'
import { useScheduleDateFiledContext } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/context/sendLaterContext'
import styles from './styles.module.scss'

type IDropdownContent = { onClose: () => void; dropdownId: string }

export const DateTimeDropdownContent = observer(({ onClose }: IDropdownContent) => {
  const { datetimeFieldDate, setDatetimeFieldDate, setUseTimeFromField } =
    useScheduleDateFiledContext()

  const [showTimePicker, setShowTimePicker] = useState(false)
  const refList = useRef<HTMLDivElement>(null)

  const handleDatetimeFieldDate = (date: Date | null) => {
    onClose()
    setDatetimeFieldDate(date)
  }

  useEffect(() => {
    if (refList.current && !IS_APP_LIGHT) {
      refList.current.querySelector('[data-selected="true"]')?.scrollIntoView()
    }
  }, [showTimePicker])

  return (
    <DropdownContent noPadding>
      {showTimePicker ? (
        <TimePicker
          selected={datetimeFieldDate}
          onChange={handleDatetimeFieldDate}
          customContent={({ onBlur, inputValue, onChangeRaw, dropdownItems, handleChange }) => (
            <div>
              <div className={styles.header}>
                <IconButton
                  ariaLabel={'back'}
                  icon={'chevronLeft'}
                  variant={'icon'}
                  size={'medium'}
                  color={'secondary'}
                  onClick={() => setShowTimePicker(false)}
                  fontSize={15}
                />
                <TextField
                  variant={'integrated'}
                  size={'small'}
                  InputProps={{
                    placeholder: 'Select a custom time',
                    onKeyDown: (event) => {
                      if (event.code === 'Enter') {
                        onBlur()
                        onClose()
                      }
                    },
                  }}
                  value={inputValue}
                  onChange={onChangeRaw}
                  onBlur={onBlur}
                />
              </div>
              <div className={styles.items} ref={refList}>
                <Scrollbar autoHeight autoHeightMax={160}>
                  {dropdownItems.map((item) => (
                    <div key={item.id} data-selected={item.activeValue}>
                      <DropdownItem
                        item={item}
                        onChange={(item) => {
                          handleChange(item)
                          onClose()
                        }}
                      />
                    </div>
                  ))}
                </Scrollbar>
              </div>
            </div>
          )}
          offsetMinutes={uiStore.offsetMinute}
        />
      ) : (
        <div className={styles.items}>
          <DropdownItem
            item={{
              id: 'useTimeFromField',
              label: 'Use the time from the field',
            }}
            onChange={() => {
              onClose()
              setUseTimeFromField(true)
            }}
          />
          <DropdownItem
            item={{
              id: 'selectTime',
              label: 'Select a custom time',
            }}
            onChange={() => {
              setShowTimePicker(true)
            }}
          />
        </div>
      )}
    </DropdownContent>
  )
})
